module.exports = __webpack_public_path__ + "img/logoClon.4eb215b3.png";